import { Component, Input, ViewChild } from '@angular/core';
import { stopPropagation } from '@rx-angular/state/actions';
import { emptyFunction } from '@libs/functions';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';


export interface AbstractGridHandlers {
    handlerRowClick?: <T>(item: T) => void;
    handlerDeleteEntity?: (id: number | string) => void;
}

@Component({
    selector: 'ui-abstract-grid',
    imports: [],
    templateUrl: './abstract-grid.component.html',
    styleUrl: './abstract-grid.component.scss'
})
export class AbstractGridComponent<T> {
    @Input()
    public displayedColumns: string[] = [];

    @Input()
    public readonly: boolean;

    @Input()
    public pending: boolean;

    @ViewChild(MatSort, { static: false })
    public set sort(sort: MatSort) {
        if (sort && this.displayEntities?.data.length) {
            this.displayEntities.sort = sort;
        }
    }

    @Input()
    public handlers: AbstractGridHandlers = {
        handlerRowClick: emptyFunction,
        handlerDeleteEntity: emptyFunction,
    };

    public readonly displayEntities: MatTableDataSource<T> =
        new MatTableDataSource<T>();

    protected readonly stopPropagation: (e: Event) => void = stopPropagation;
}
